module.exports = __webpack_public_path__ + "static/media/piano-bonk.40fe7620.mp3";